import formatDate from '../helpers/formatDate.js';
import getOrderNumber from '../helpers/orderNumber.js';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export default class CreditMemoStatement {

    #LEFT_MARGIN = 14;
    #RIGHT_MARGIN = 200;
    #CURRENT_Y = 0;

    constructor(customerData, invoiceData) {
        const now = new Date();
        this.customer = customerData;
        this.invoice = invoiceData;
        this.statementDate = formatDate(now.toISOString());
        this.doc = new jsPDF();
        this.logoBase64 = null;
    }

    
    async loadLogoFromUrl(url) {
        const response = await fetch(url);
        const blob = await response.blob();
        const reader = new FileReader();
    
        return new Promise((resolve, reject) => {
            reader.onloadend = () => {
                this.logoBase64 = reader.result;
                resolve();
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }
    

    renderCompanyHeader() {
        this.doc.setFontSize(12);
        this.doc.text('Swallow Dental Supplies Ltd.', this.#LEFT_MARGIN, 15);
        this.doc.setFontSize(10);
        this.doc.text('Unit 5 Marrtree Business Park', this.#LEFT_MARGIN, 20);
        this.doc.text('Ryefield Way', this.#LEFT_MARGIN, 25);
        this.doc.text('Silsden, West Yorkshire, BD20 0EF', this.#LEFT_MARGIN, 30);
        this.doc.text('United Kingdom', this.#LEFT_MARGIN, 35);
        this.doc.text('T 01535 656312    F 01535 656437', this.#LEFT_MARGIN, 40);
        this.doc.text('VAT Reg No. 721604174    Co. Reg. 03652780', this.#LEFT_MARGIN, 45);
    }

    renderStatementTitle() {
        if (this.logoBase64) {
            this.doc.addImage(this.logoBase64, 'PNG', this.#RIGHT_MARGIN - 40, 15, 40, 13);
        }
        this.doc.setFontSize(14);
        this.doc.setFont(undefined, 'bold');
        this.doc.text(this.invoice.id, this.#RIGHT_MARGIN, 40, { align: 'right' });
        this.doc.setFont(undefined, 'normal');
    }

    renderCustomerDetails() {
        this.#CURRENT_Y = this.doc.lastAutoTable.finalY + 10;
        this.doc.setFontSize(9);
        this.doc.setFont(undefined, 'bold');
        this.doc.text('CREDIT DETAILS', this.#LEFT_MARGIN, this.#CURRENT_Y);
        this.doc.setFont(undefined, 'normal');
        this.#CURRENT_Y += 7;
        this.doc.setFont(undefined, 'bold');
        this.doc.text("Credit Date", this.#LEFT_MARGIN, this.#CURRENT_Y);
        this.doc.setFont(undefined, 'normal');
        this.doc.text(formatDate(this.invoice.attributes.date), this.#LEFT_MARGIN + 60, this.#CURRENT_Y, {
            align: 'right'
        });
        this.#CURRENT_Y += 5;
        this.doc.setFont(undefined, 'bold');
        this.doc.text("Account Number", this.#LEFT_MARGIN, this.#CURRENT_Y);
        this.doc.setFont(undefined, 'normal');
        this.doc.text(this.customer.accountNumber, this.#LEFT_MARGIN + 60, this.#CURRENT_Y, {
            align: 'right'
        });
        this.#CURRENT_Y += 5;
        this.doc.setFont(undefined, 'bold');
        this.doc.text("Currency", this.#LEFT_MARGIN, this.#CURRENT_Y);
        this.doc.setFont(undefined, 'normal');
        this.doc.text("GBP", this.#LEFT_MARGIN + 60, this.#CURRENT_Y, {
            align: 'right'
        });
        this.#CURRENT_Y += 5;
        this.doc.setFont(undefined, 'bold');
        this.doc.text("Invoice Number", this.#LEFT_MARGIN, this.#CURRENT_Y);
        this.doc.setFont(undefined, 'normal');
        this.doc.text(this.invoice.attributes.reference2, this.#LEFT_MARGIN + 60, this.#CURRENT_Y, {
            align: 'right'
        });
        // this.#CURRENT_Y -= 5;
        // this.doc.setFont(undefined, 'bold');
        // this.doc.text("Payment Term", this.#LEFT_MARGIN + 70, this.#CURRENT_Y);
        // this.doc.setFont(undefined, 'normal');
        // this.doc.text("Don't know", this.#LEFT_MARGIN + 120, this.#CURRENT_Y, {
        //     align: 'right'
        // });
        // this.#CURRENT_Y -= 15;
        // this.doc.setFont(undefined, 'bold');
        // this.doc.text("Due Date", this.#LEFT_MARGIN + 70, this.#CURRENT_Y);
        // this.doc.setFont(undefined, 'normal');
        // this.doc.text(formatDate(this.invoice.dueDate), this.#LEFT_MARGIN + 120, this.#CURRENT_Y, {
        //     align: 'right'
        // });
        this.#CURRENT_Y -= 15;
        this.doc.setFont(undefined, 'bold');
        this.doc.text("Order Reference", this.#LEFT_MARGIN + 70, this.#CURRENT_Y);
        this.doc.setFont(undefined, 'normal');
        this.doc.text(this.invoice.reference, this.#LEFT_MARGIN + 120, this.#CURRENT_Y, {
            align: 'right'
        });
        this.#CURRENT_Y += 5;
        this.doc.setFont(undefined, 'bold');
        this.doc.text("Order Number", this.#LEFT_MARGIN + 70, this.#CURRENT_Y);
        this.doc.setFont(undefined, 'normal');
        this.doc.text(getOrderNumber(this.invoice), this.#LEFT_MARGIN + 120, this.#CURRENT_Y, {
            align: 'right'
        });
        this.#CURRENT_Y += 10;
    }

    renderInvoiceTable() {
        const invoiceHeaders = [
            'Item Name',
            'Quantity',
            // 'Backorder',
            'Unit Measure',
            'Item Description',
            // 'Disc %',
            'Unit Price',
            'Line Total'
        ];

        const invoiceRows = this.invoice.attributes.details.map(item => [
            item.itemName,
            item.qty,
            item.um,
            item.description,
            parseFloat(item.sellPrice).toFixed(2),
            parseFloat(item.lineTotal).toFixed(2),
        ])
    
        // const invoiceRows = [
        //     ['Tooth Scaler', '10', '2', 'Each', 'Stainless steel scaler tool', '5%', '£12.00', '£114.00'],
        //     ['Face Masks', '100', '0', 'Box', 'Disposable 3-ply masks', '0%', '£8.00', '£800.00'],
        //     ['Surgical Gloves', '50', '10', 'Box', 'Latex-free gloves', '10%', '£6.50', '£292.50'],
        //     ['Dental Mirror', '25', '5', 'Each', 'Anti-fog dental mirrors', '7%', '£3.00', '£83.25']
        // ];
    
        this.#CURRENT_Y += 10;
    
        autoTable(this.doc, {
            startY: this.#CURRENT_Y,
            head: [invoiceHeaders],
            body: invoiceRows,
            styles: {
                fontSize: 8,
                cellPadding: 2,
                valign: 'middle',
            },
            headStyles: {
                fillColor: '#020023',
                textColor: '#ffffff',
            },
            theme: 'grid',
            // columnStyles: {
            //     0: { cellWidth: 30 }, // Item Name
            //     1: { cellWidth: 15 }, // Shipped
            //     2: { cellWidth: 20 }, // Backorder
            //     3: { cellWidth: 20 }, // Unit Measure
            //     4: { cellWidth: 50 }, // Item Description
            //     5: { cellWidth: 15 }, // Disc %
            //     6: { cellWidth: 20 }, // Unit Price
            //     7: { cellWidth: 20 }, // Line Total
            // }
        });
    
        this.#CURRENT_Y = this.doc.lastAutoTable.finalY;
    }

    renderInvoiceFooterTotals() {
        const subTotal = `£${parseFloat(this.invoice.attributes.subTotal).toFixed(2)}`;
        const shipping = `£${parseFloat(this.invoice.attributes.freight).toFixed(2)}`;
        const vatAmount = `£${parseFloat(this.invoice.attributes.tax).toFixed(2)}`;
        const invoiceTotal = `£${parseFloat(this.invoice.attributes.total).toFixed(2)}`;
    
        // Define the Y position where this section will start
        const footerY = this.#CURRENT_Y + 10; // You can adjust this as needed
        
        // Set font style and size for totals
        this.doc.setFontSize(10);
        
        // Position and align totals to the right
        const rightMargin = this.#RIGHT_MARGIN - 60;
    
        // Subtotal
        this.doc.setFont(undefined, 'bold');
        this.doc.text(`Subtotal`, rightMargin, footerY);
        this.doc.setFont(undefined, 'normal');
        this.doc.text(subTotal, this.#RIGHT_MARGIN, footerY, {
            align: 'right'
        });
    
        // Shipping
        this.doc.setFont(undefined, 'bold');
        this.doc.text(`Shipping`, rightMargin, footerY + 7);
        this.doc.setFont(undefined, 'normal');
        this.doc.text(shipping, this.#RIGHT_MARGIN, footerY + 7, {
            align: 'right'
        });
    
        // VAT Amount
        this.doc.setFont(undefined, 'bold');
        this.doc.text(`Tax`, rightMargin, footerY + 14);
        this.doc.setFont(undefined, 'normal');
        this.doc.text(vatAmount, this.#RIGHT_MARGIN, footerY + 14, {
            align: 'right'
        });
        this.doc.line(this.#RIGHT_MARGIN - 30, footerY + 16, this.#RIGHT_MARGIN, footerY + 16, 'S');
    
        // Invoice Total
        this.doc.setFont(undefined, 'bold');
        this.doc.text(`Total`, rightMargin, footerY + 21);
        this.doc.setFont(undefined, 'normal');
        this.doc.text(invoiceTotal, this.#RIGHT_MARGIN, footerY + 21, {
            align: 'right'
        });
        
        // Update CURRENT_Y to reflect where the next content starts
        this.#CURRENT_Y = footerY + 20; // Adjust based on how much space you need
    }
    
    

    renderAddressTable() {
        this.#CURRENT_Y = 55;
    
        autoTable(this.doc, {
            startY: this.#CURRENT_Y,
            head: [['Billing Address']],
            body: [
                [
                    this.invoice.attributes.billToNameAndAddres
                ]
            ],
            styles: {
                fontSize: 10,
                cellPadding: 2,
                valign: 'top',
            },
            headStyles: {
                fillColor: '#020023',
                textColor: '#ffffff',
            },
            theme: 'grid',
        });
    
        this.#CURRENT_Y = this.doc.lastAutoTable.finalY;
    }

    renderDocumentFooter()
    {
        // Aged Analysis section (dummy values)
        const finalY = this.#CURRENT_Y + 10;

        // Bank details
        const bankY = finalY + 25;
        this.doc.setFont(undefined, 'bold');
        this.doc.text('Bank Payment', this.#LEFT_MARGIN, bankY);
        
        this.doc.setFont(undefined, 'normal');
        this.doc.text('Swallow Dental Supplies Ltd', this.#LEFT_MARGIN, bankY + 8);
        this.doc.text('Account No: 63590660', this.#LEFT_MARGIN, bankY + 13);
        this.doc.text('Sort Code: 30-63-55', this.#LEFT_MARGIN, bankY + 19);

        this.doc.text('Please use your Account No. shown above as the reference.', this.#LEFT_MARGIN, bankY + 25, {
            maxWidth: 80
        });
        
        this.doc.setFont(undefined, 'bold');
        this.doc.text('Card Payment', this.#LEFT_MARGIN + 90, bankY);
        this.doc.setFont(undefined, 'normal');
        this.doc.text('Please call 01535 656312 (option 3) to use our 24/7 payment line.', this.#LEFT_MARGIN + 90, bankY + 8, {
            maxWidth: 80
        });
        this.doc.text('Or email finance@swallowdental.co.uk to request an Opayo PayByLink.', this.#LEFT_MARGIN + 90, bankY + 19, {
            maxWidth: 80
        });

        // Footer
        this.doc.setFontSize(10);
        this.doc.text(`Date Printed: ${this.statementDate}`, this.#LEFT_MARGIN, 285);
        this.doc.text('Page 1 of 1', this.#RIGHT_MARGIN, 285, { align: 'right' });
    }

    async generate()
    {
        console.log('invoice data',this.invoice);
        console.log('customer data', this.customer);
        // Company Header (Top Left)
        this.renderCompanyHeader();

        // Statement Title (Top Right)
        this.renderStatementTitle();

        // Addresses
        this.renderAddressTable();

        this.renderCustomerDetails();

        // // Table Heading
        if(this.invoice.attributes.details.length){
            this.renderInvoiceTable();
        }

        // Table Totals
        this.renderInvoiceFooterTotals();

        // // Document Footer
        this.renderDocumentFooter();

        // Save file
        this.doc.save(`${this.invoice.id}.pdf`);
    }
}